import styled from 'styled-components';

export const Wrapper = styled.div`
  position: fixed;
  padding: 15px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease-in-out;
  @media (max-width: 600px) {
    
    overflow: auto;
    padding: 0;
  }
  &.active {
    opacity: 1;
    visibility: visible;
  }

  .modal-mask {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #41609b;
    opacity: 0.3;
  }
  .close-btn {
    position: absolute;
    top: 25px;
    right: 25px;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
  }
  .primary-button {
    font-size: 20px;
    width: 100%;
    border-radius: 53px;
    margin: 20px auto 0;
    max-width: 270px;
    padding: 10px 40px;
    display: block;
    @media (max-width: 600px) {
      font-size: 18px;
    }
  }
  .no-button {
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    color: #fff;
    text-decoration: underline;
    border: none;
    background: none;
    margin-top: 20px;
  }
`;

export const Container = styled.div`
  max-width: 566px;
  width: 100%;
  border-radius: 8px;
  position: relative;
  z-index: 10;
  background: #b8171d;
  padding: 40px 30px 30px;
  position: relative;

  > img {
    width: 80px;
    margin-bottom: 20px;
  }
  .close-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 10px;
    right: 10px;
    img {
      width: 100%;
    }
  }
  @media (max-width: 600px) {
    border-radius: 0;
  }
  > section {
    padding: 40px 0 50px;

    @media (max-width: 600) {
      padding: 20px;
    }
  }
`;
